import { apiClient, Auth } from '@/shared/api'

import { TPaymentMethod } from '../model/schema'

export type CheckOutChecklist = {
  isInterimLeave: boolean
  initialContractPayType: TPaymentMethod
  rid: number
  roomName: string
  picMain: string | null
  isScoreAvailable: boolean
  isReviewAvailable: boolean
  isSimpleReviewExists: boolean
}

export const getCheckOutChecklist = async (initialContractId: number) => {
  const { data } = await apiClient.get<CheckOutChecklist>({
    endpoint: `/guest/contracts/${initialContractId}/check-out/checklist`,
    auth: Auth.REQUIRED,
  })

  return data
}
